import { useState } from 'react';
import { Input, Checkbox, Button } from 'antd';
import { SearchOutlined, StopOutlined } from '@ant-design/icons';
import '../groupSelect/styles.scss';

interface Stage {
  id:     string;
  label:  string;
  color?: string;   // colored square
  emoji?: string;   // emoji icon
  none?:  boolean;  // "No value set"
}

interface Props {
  open:      boolean;
  onClose:   () => void;
  onSelect?: (ids: string[]) => void;
  selected?: string[];
}

const STAGES: Stage[] = [
  { id: '__none__',       label: 'No value set',   none: true },
  { id: 'interested',     label: 'Interested',     color: '#d5d5d5' },
  { id: 'meeting_booked', label: 'Meeting Booked', color: '#f5a623' },
  { id: 'proposal',       label: 'Proposal',       color: '#9b59b6' },
  { id: 'negotiating',    label: 'Negotiating',    color: '#3498db' },
  { id: 'closed_won',     label: 'Closed - Won',   emoji: '✅' },
  { id: 'closed_lost',    label: 'Closed - Lost',  emoji: '❌' },
  { id: 'uncontactable',  label: 'Uncontactable',  emoji: '✖️' },
];

const LeadStageSelect = ({ open, onClose, onSelect, selected = [] }: Props) => {
  const [search, setSearch] = useState('');
  const [picked, setPicked] = useState<string[]>(selected);

  const filtered = STAGES.filter(s => s.label.toLowerCase().includes(search.toLowerCase()));

  const toggle = (id: string) =>
    setPicked(prev => (prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]));

  const handleDone = () => {
    onSelect?.(picked);
    onClose();
  };

  if (!open) return null;

  return (
    <div className="group-select">
      <div className="gs-search">
        <Input
          placeholder="Search"
          prefix={<SearchOutlined style={{ color: '#999' }} />}
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div className="gs-list">
        {filtered.map(s => (
          <div key={s.id} className="gs-item" onClick={() => toggle(s.id)}>
            {s.none ? (
              <span className="gs-none-icon"><StopOutlined /></span>
            ) : s.emoji ? (
              <span className="gs-src-icon">{s.emoji}</span>
            ) : (
              <span className="gs-dot" style={{ background: s.color }} />
            )}
            <span className="gs-label">{s.label}</span>
            <Checkbox
              checked={picked.includes(s.id)}
              onClick={e => e.stopPropagation()}
              onChange={() => toggle(s.id)}
            />
          </div>
        ))}

        {filtered.length === 0 && <div className="gs-empty">No stages found</div>}
      </div>

      <div className="gs-done">
        <Button type="primary" block size="large" onClick={handleDone}>
          ✓ DONE
        </Button>
      </div>
    </div>
  );
};

export default LeadStageSelect;
